import {CompleteIcon} from './complete.icon';
import {CheckIcon} from './check.icon';
import {ArrowLeftIcon} from './arrow.left.icon';
import {AccountIcon} from './account.icon';
import {CardIcon, MasterCardIcon, VisaCardIcon} from './card.icon';
import {CardTransferMenuIcon} from './card.transfer.menu.icon';
import {CardActivationIcon} from './card.activation.icon';
import {LeavePageIcon} from "./leave.page.icon";
import {SenderAccountIcon} from "./sender.account.icon";
import {VerifyCheckIcon} from "./verify.check.icon";
import {WarningIcon} from "./warning.icon";
import {ChevronRightIcon} from "./chevron-right.icon";
import {ChevronBottomIcon} from "./chevron-bottom.icon";
import {SearchBusinessCategoryIcon} from "./search-business-category.icon";
import {FavouriteAccountIcon} from "./favourite.account.icon";

export const ICONS = [
    CompleteIcon,
    CheckIcon,
    ArrowLeftIcon,
    AccountIcon,
    CardIcon,
    VisaCardIcon,
    MasterCardIcon,
    CardActivationIcon,
    CardTransferMenuIcon,
    LeavePageIcon,
    SenderAccountIcon,
    FavouriteAccountIcon,
    VerifyCheckIcon,
    WarningIcon,
    CardTransferMenuIcon,
    ChevronRightIcon,
    ChevronBottomIcon,
    SearchBusinessCategoryIcon
];

export * from './card.icon';
export * from './account.icon';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/index.ts